module.exports = __webpack_public_path__ + "static/media/20160418_203544.96245286.jpg";